export enum EventTypes {
  QUIZ_START = "quizStart",
  QUIZ_VIEW = "quizView",
  QUIZ_STEP = "quizStep",
  QUIZ_LINK = "quizLink",
  QUIZ_END = "quizEnd",
}

export interface EventDetails {
  quizName: string;
  quizStepName?: string;
  quizStepId?: number;
  quizResult?: boolean;
  quizHelps?: string[];
  quizRemainingTime?: number;
  quizMoves?: number;
}

export interface DispatchEventAction {
  payload: { eventType: EventTypes; extraData: any };
}

export interface EventsState {}
